import React from 'react';

import { RealignGrid } from '../RealignPanel/RealignGrid';
import { ParentOKRSelectionRadioButton } from './ParentOKRSelectionRadioButton';

export const ParentOKRSelectionGrid = ({ gridData, gridRef, selectedParent, setSelectedParent }) => (
  <RealignGrid
    selectedParentUuid={selectedParent?.uuid}
    setSelectedParentUuid={setSelectedParent}
    gridRef={gridRef}
    gridData={gridData}
    SelectionComponent={ParentOKRSelectionRadioButton}
  />
);
